// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-container {
  text-align: left; /* Align text to the left */
  padding: 20px; /* Add some padding */
  background-color: rgba(0, 0, 0, 0); /* Optional: add a dark overlay */
  border-radius: 8px; /* Optional: round the corners */
}

.contact-section .row {
  margin-top: 0 !important;
}
/* Align left and right columns perfectly at the top */
.contact-section .row.align-columns {
  display: flex;
  align-items: flex-start !important;
}

/* Remove unwanted gap above the left form */
.order-md-1 {
  margin-top: 0 !important;
}

/* Reduce top space overall */
.contact-section .container {
  padding-top: 0 !important;
}

/* Prevent AOS from pushing the columns down */
/* [data-aos] {
  transform: none !important;
} */

.contact_title {
  font-size: 4rem;
  color: #ffffff;
  border-bottom: 1px solid #FFE600;
  display: inline-block; /* Make the title's border wrap around the text */
  padding-bottom: 10px; /* Optional: Add some space between the text and the border */
  margin-top: 15px;
}

.subtext {
  color: #aab5b7;
}

.location_highlight {
  color: #FFE600;
  border-bottom: 1px solid #FFE600;
}

/* Additional responsive adjustments if necessary */
@media (max-width: 768px) {
  .contact_title {
    font-size: 3rem; 
    margin-top: 75px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/PAGES/CONTACT/SECTIONS/CONTACT/index.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB,EAAE,2BAA2B;EAC7C,aAAa,EAAE,qBAAqB;EACpC,kCAAkC,EAAE,iCAAiC;EACrE,kBAAkB,EAAE,gCAAgC;AACtD;;AAEA;EACE,wBAAwB;AAC1B;AACA,sDAAsD;AACtD;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA,4CAA4C;AAC5C;EACE,wBAAwB;AAC1B;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;AAC3B;;AAEA,8CAA8C;AAC9C;;GAEG;;AAEH;EACE,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,qBAAqB,EAAE,iDAAiD;EACxE,oBAAoB,EAAE,6DAA6D;EACnF,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA,mDAAmD;AACnD;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":[".text-container {\n  text-align: left; /* Align text to the left */\n  padding: 20px; /* Add some padding */\n  background-color: rgba(0, 0, 0, 0); /* Optional: add a dark overlay */\n  border-radius: 8px; /* Optional: round the corners */\n}\n\n.contact-section .row {\n  margin-top: 0 !important;\n}\n/* Align left and right columns perfectly at the top */\n.contact-section .row.align-columns {\n  display: flex;\n  align-items: flex-start !important;\n}\n\n/* Remove unwanted gap above the left form */\n.order-md-1 {\n  margin-top: 0 !important;\n}\n\n/* Reduce top space overall */\n.contact-section .container {\n  padding-top: 0 !important;\n}\n\n/* Prevent AOS from pushing the columns down */\n/* [data-aos] {\n  transform: none !important;\n} */\n\n.contact_title {\n  font-size: 4rem;\n  color: #ffffff;\n  border-bottom: 1px solid #FFE600;\n  display: inline-block; /* Make the title's border wrap around the text */\n  padding-bottom: 10px; /* Optional: Add some space between the text and the border */\n  margin-top: 15px;\n}\n\n.subtext {\n  color: #aab5b7;\n}\n\n.location_highlight {\n  color: #FFE600;\n  border-bottom: 1px solid #FFE600;\n}\n\n/* Additional responsive adjustments if necessary */\n@media (max-width: 768px) {\n  .contact_title {\n    font-size: 3rem; \n    margin-top: 75px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
